import { makeStyles, Card, Grid } from '@material-ui/core';
import { colors } from 'design-system';

type Props = {
  paymentAmount: number;
  montlyPayment: number;
  totalPayment: number;
};

const useStyle = makeStyles({
  cardRoot: {
    backgroundColor: colors.madison,
    borderRadius: 10,
    color: colors.white,
    padding: 16,
    paddingLeft: 26,
    position: 'relative',
  },
  arrow: {
    width: 0,
    height: 0,
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    borderLeft: '16px solid white',
    position: 'absolute',
    bottom: 26,
    left: 0,
  },
  mediumText: {
    fontSize: 18,
    fontWeight: 300,
    lineHeight: '27px',
  },
  smallText: {
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '18px',
  },
  largeText: {
    fontWeight: 800,
    fontSize: 22,
    lineHeight: '33px',
  },
});

const QuoteResume = ({
  paymentAmount,
  montlyPayment,
  totalPayment,
}: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <Card className={classes.cardRoot}>
      <div className={classes.arrow} />
      <Grid container>
        <Grid item xs={6} container>
          <Grid item xs={12}>
            <span className={classes.mediumText}>{paymentAmount} Cuotas</span>
          </Grid>
          <Grid item xs={12}>
            <span className={classes.largeText}>
              ${montlyPayment.toFixed(2)}
            </span>
            &nbsp;
            <span className={classes.smallText}>/ mes</span>
          </Grid>
        </Grid>
        <Grid item xs={6} container>
          <Grid item xs={12}>
            <span className={classes.mediumText}>Total</span>
          </Grid>
          <Grid item xs={12}>
            <span className={classes.largeText}>
              ${totalPayment.toFixed(2)}
            </span>
            &nbsp;
            <span className={classes.smallText}>/ anual</span>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
export default QuoteResume;
